import { Redirect, Route, Switch } from "react-router-dom";

import CreatorPortal from "./components/portals/creatorPortal";
import OnboardingPortal from "./components/portals/onboardingPortal";
import PatientPortal from "./components/portals/patientPortal";

import constants from "./assets/constants";

const getOmniOrganizationPortal = awsGroup => {
  if (awsGroup === constants.userGroups.Creator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathCreator}>
          <CreatorPortal />
        </Route>

        <Route exact path={constants.appPaths.appPathCreatorDemoOnboarding}>
          <OnboardingPortal />
        </Route>

        <Route exact path={constants.appPaths.appPathCreatorDemoPatient}>
          <PatientPortal />
        </Route>

        <Route render={() => <Redirect to={constants.appPaths.appPathCreator} />} />
      </Switch>
    );
  }
};

export default getOmniOrganizationPortal;
